import { ErrorResponse, Link, useRouteError } from 'react-router-dom';
import { useLanguage } from '../useLanguage';
import { useTheme } from '../contexts/ThemeContext';

const ErrorPage = () => {
  const error = useRouteError() as ErrorResponse;
  const { lang, setLang, t } = useLanguage();
  const { isDark, toggleTheme } = useTheme();

  return (
    <main id="error-page" className="min-h-screen bg-gray-50 dark:bg-dark-900 px-4 py-16 grid place-items-center">
      <div className="fixed right-4 top-4 flex items-center gap-2">
        <div className="language-switch" role="group" aria-label={t.header.language}>
          {(['en', 'es'] as const).map((language) => (
            <button
              key={language}
              type="button"
              className="language-option"
              data-active={lang === language}
              aria-pressed={lang === language}
              aria-label={language === 'en' ? 'English' : 'Español'}
              onClick={() => setLang(language)}
            >
              {language.toUpperCase()}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={toggleTheme}
          className="min-w-11 min-h-11 rounded-lg text-xl text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-800"
          aria-label={isDark ? t.header.lightMode : t.header.darkMode}
        >
          {isDark ? '☀' : '☾'}
        </button>
      </div>
      <section className="max-w-2xl text-center">
        <div className="text-primary-700 dark:text-primary-300 text-sm font-semibold mb-4">
          {error.status || t.error.label}
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-white mb-4">
          {t.error.title}
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-3">{t.error.message}</p>
        <Link to="/" className="btn-primary inline-flex items-center justify-center">
          {t.error.backHome}
        </Link>
      </section>
    </main>
  );
};
  
export default ErrorPage;
